import React from 'react';
import { CRM_COLORS } from '../theme/crmColors';
import { types, redirect_to_types } from './paths';
import Authentication from '../components/auth/Authentication';
import { User } from '../utils/types';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../redux/reducers';
import TypesList from '../components/type/list';
import { Box } from '@material-ui/core';
import IntegratedHeader from '../components/header/IntegratedHeader';
import { useTranslate } from 'react-admin';

const TypesPage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();

    return (
        <Authentication redirectTo={redirect_to_types}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={types}
                        eyebrow={translate('app.headers.eyebrow.reference')}
                        title={translate('app.headers.types')}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            minHeight: 0,
                            height: '100%',
                        }}
                    >
                        <TypesList />
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default TypesPage;
